
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.162 15.551a3.175 3.175 0 01-2.353-1.156 1.069 1.069 0 00-1.509-.152c-.048.048-.104.097-.145.152a3.194 3.194 0 01-4.492.43 3.656 3.656 0 01-.436-.43 1.07 1.07 0 00-1.516-.145c-.048.048-.097.09-.138.145a3.194 3.194 0 01-4.492.43 2.838 2.838 0 01-.436-.43 1.069 1.069 0 00-1.51-.152 1.002 1.002 0 00-.144.152 3.175 3.175 0 01-2.354 1.156.657.657 0 10.049 1.315 4.52 4.52 0 003.128-1.419 4.514 4.514 0 006.375.208c.076-.07.145-.138.214-.208a4.514 4.514 0 006.375.208l.207-.208a4.522 4.522 0 003.136 1.42.657.657 0 10.041-1.316z","fill":"currentColor"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M11.7 3v19"}}),_c('path',{attrs:{"d":"M11.7 26l-3.897-4.5h7.794L11.7 26z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M18.7 3v8.5","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M18.7 15.367l-3.724-4.3h7.448l-3.724 4.3z","fill":"currentColor"}})])
          )
        }
      }
    